/* eslint-disable no-unused-vars */
import { useEffect } from 'react';
import { authAPI } from 'services/newPlatformAuth.service';
import { showPolipop } from 'utils';
import * as S from './ForgotPassword.styled';

export const ForgotPasswordSuccess = ({ data }) => {
  const [ResendForgotPasswordEmailAction, result] = authAPI.useResendForgotPasswordEmailMutation();

  function handleResend() {
    ResendForgotPasswordEmailAction(data);
  }

  useEffect(() => {
    showPolipop(result);
  }, [result]);

  return (
    <S.SubmitSuccessfulBox>
      <S.Title>Thanks!</S.Title>
      <S.SuccessText>
        Please check your email for instructions <br />
        on how to reset your password.
        <br />
        <br />
        No message received?
        <br />
        Check your spam folders or{' '}
        <S.SuccessLink onClick={handleResend}>Resend the Email</S.SuccessLink>
      </S.SuccessText>
    </S.SubmitSuccessfulBox>
  );
};
